import React from 'react';
import { Droplet, Gauge, Ruler } from 'lucide-react';

/**
 * Компонент выбора типа расчета
 */
const CalculationTypeSection = ({ formData, handleInputChange, errors }) => {
  return (
    <div className="mb-6">
      <div className="block text-base font-medium text-gray-700 dark:text-gray-300 mb-2">
        Выберите тип расчета
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
        <label
          className={`p-4 border rounded-lg transition-colors cursor-pointer
            ${
              formData.calculationType === 'flowRate'
                ? 'bg-blue-100 border-blue-300 dark:bg-blue-900/30 dark:border-blue-700'
                : 'bg-gray-50 border-gray-200 hover:bg-gray-100 dark:bg-gray-800 dark:border-gray-700 dark:hover:bg-gray-700'
            }`}
        >
          <input
            type="radio"
            name="calculationType"
            value="flowRate"
            checked={formData.calculationType === 'flowRate'}
            onChange={handleInputChange}
            className="sr-only"
          />
          <div className="flex flex-col items-center text-center">
            <Droplet 
              className={`w-6 h-6 mb-2 ${
                formData.calculationType === 'flowRate'
                  ? 'text-blue-600 dark:text-blue-400'
                  : 'text-gray-600 dark:text-gray-400'
              }`} 
            />
            <div className="font-medium">Расход воды</div>
            <div className="text-xs mt-1 text-gray-600 dark:text-gray-400">
              Расчет расхода по известному перепаду давления
            </div>
          </div>
        </label>

        <label
          className={`p-4 border rounded-lg transition-colors cursor-pointer
            ${
              formData.calculationType === 'pressure'
                ? 'bg-blue-100 border-blue-300 dark:bg-blue-900/30 dark:border-blue-700'
                : 'bg-gray-50 border-gray-200 hover:bg-gray-100 dark:bg-gray-800 dark:border-gray-700 dark:hover:bg-gray-700'
            }`}
        >
          <input
            type="radio"
            name="calculationType"
            value="pressure"
            checked={formData.calculationType === 'pressure'}
            onChange={handleInputChange}
            className="sr-only"
          />
          <div className="flex flex-col items-center text-center">
            <Gauge 
              className={`w-6 h-6 mb-2 ${
                formData.calculationType === 'pressure'
                  ? 'text-blue-600 dark:text-blue-400'
                  : 'text-gray-600 dark:text-gray-400'
              }`} 
            />
            <div className="font-medium">Перепад давления</div>
            <div className="text-xs mt-1 text-gray-600 dark:text-gray-400">
              Расчет перепада давления по заданному расходу
            </div>
          </div>
        </label>

        <label
          className={`p-4 border rounded-lg transition-colors cursor-pointer
            ${
              formData.calculationType === 'diameter'
                ? 'bg-blue-100 border-blue-300 dark:bg-blue-900/30 dark:border-blue-700'
                : 'bg-gray-50 border-gray-200 hover:bg-gray-100 dark:bg-gray-800 dark:border-gray-700 dark:hover:bg-gray-700'
            }`}
        >
          <input
            type="radio"
            name="calculationType"
            value="diameter"
            checked={formData.calculationType === 'diameter'}
            onChange={handleInputChange}
            className="sr-only"
          />
          <div className="flex flex-col items-center text-center">
            <Ruler 
              className={`w-6 h-6 mb-2 ${
                formData.calculationType === 'diameter'
                  ? 'text-blue-600 dark:text-blue-400'
                  : 'text-gray-600 dark:text-gray-400'
              }`} 
            />
            <div className="font-medium">Диаметр трубы</div>
            <div className="text-xs mt-1 text-gray-600 dark:text-gray-400">
              Подбор оптимального диаметра трубы
            </div>
          </div>
        </label>
      </div>
      {errors.calculationType && (
        <p className="mt-1 text-xs text-red-500">{errors.calculationType}</p>
      )}
    </div>
  );
};

export default CalculationTypeSection;